import { DedicatedTeamsState, IDedicatedTeamsState } from '@components/services/dedicated-teams/dedicated-teams.state';
import DedicatedDevelopmentTeamsSection from '@components/services/dedicated-teams/sections/dedicated-development-teams-section/dedicated-development-teams-section';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import { StartProjectComponent } from '../../shared/interactions/start-project-component';
import { scrollToBlock } from '../../../@services/scrollToBlock';
import { StartProjectBlock } from '../../shared/blocks/start-project-block';
import FAQSection from '@components/shared/blocks/faq/index';
import OutsourcingToDedicatedTeams from '@components/services/dedicated-teams/sections/outsourcing-to-dedicated-teams/outsourcing-to-dedicated-teams';
import WhatIsDedicatedTeamSection from '@components/services/dedicated-teams/sections/what-is-dedicated-team/what-is-dedicated-team';
import WhyHireDedicatedTeamSection from '@components/services/dedicated-teams/sections/why-hire-dedicated-team/why-hire-dedicated-team';
import BenefitsOfDedicatedTeamsSection from '@components/services/dedicated-teams/sections/benefits-of-dedicated-teams/benefits-of-dedicated-teams';
import ComparingDedicatedTeamSection from './sections/comparing-dedicated-team/comparing-dedicated-team';
import HowToHireTeamSection from '@components/services/dedicated-teams/sections/how-to-hire-team/how-to-hire-team';
import HowToManageTeamSection from './sections/how-to-manage-team/how-to-manage-team';
import BestOptionSection from '@components/services/dedicated-teams/sections/best-option/best-option';
import style from './dedicated-teams.module.scss';
import template from '@styles/reusable.styles.module.scss';
import reusable from '@styles/reusable.styles.module.scss';
import StartBusiness from '@components/shared/start-business';
import { Themes } from '@layouts/main-layout/themes.enum';

const DedicatedTeamsComponent = () => {
  const {
    dedicatedDevelopmentTeamsSection,
    newProjectSection,
    FAQSection: faqSection,
    outsourcingToDedicatedTeamsSection,
    whatIsDedicatedTeamSection,
    whyHireDedicatedTeamSection,
    benefitsOfDedicatedTeamsSection,
    comparingDedicatedTeamSection,
    howToHireTeamSection,
    howToManageTeamSection,
    bestOptionSection,
    startBusiness,
  }: IDedicatedTeamsState = DedicatedTeamsState;

  return (
    <>
      <Breadcrumbs />
      <DedicatedDevelopmentTeamsSection
        imageSrc={dedicatedDevelopmentTeamsSection.imageSrc}
        title={dedicatedDevelopmentTeamsSection.title}
        text={dedicatedDevelopmentTeamsSection.text}
      />
      <section className={`${style.section} ${template.section_gray}`}>
        <OutsourcingToDedicatedTeams
          imageSrc={outsourcingToDedicatedTeamsSection.imageSrc}
          title={outsourcingToDedicatedTeamsSection.title}
          text={outsourcingToDedicatedTeamsSection.text}
          list={outsourcingToDedicatedTeamsSection.list}
        />
      </section>
      <WhatIsDedicatedTeamSection
        imageSrc={whatIsDedicatedTeamSection.imageSrc}
        title={whatIsDedicatedTeamSection.title}
        paragraphs={whatIsDedicatedTeamSection.paragraphs}
      />
      <WhyHireDedicatedTeamSection
        title={whyHireDedicatedTeamSection.title}
        description={whyHireDedicatedTeamSection.description}
        items={whyHireDedicatedTeamSection.items}
      />
      <BenefitsOfDedicatedTeamsSection
        title={benefitsOfDedicatedTeamsSection.title}
        description={benefitsOfDedicatedTeamsSection.description}
        items={benefitsOfDedicatedTeamsSection.items}
      />
      <ComparingDedicatedTeamSection
        title={comparingDedicatedTeamSection.title}
        models={comparingDedicatedTeamSection.models}
      />
      <HowToHireTeamSection title={howToHireTeamSection.title} steps={howToHireTeamSection.steps} />
      <StartProjectBlock
        title={newProjectSection.title}
        buttonText={newProjectSection.buttonText}
        showIntoView={() => scrollToBlock('start-project-form')}
      />
      <HowToManageTeamSection
        title={howToManageTeamSection.title}
        description={howToManageTeamSection.description}
        imageSrc={howToManageTeamSection.imageSrc}
        advices={howToManageTeamSection.advices}
      />
      <BestOptionSection
        title={bestOptionSection.title}
        description={bestOptionSection.description}
        industriesTitle={bestOptionSection.industriesTitle}
        industries={bestOptionSection.industries}
        card={bestOptionSection.card}
      />
      <StartBusiness startBusiness={startBusiness} theme={Themes.DarkGray} />
      <section className={`${style.section} ${template.section_light}`}>
        <FAQSection title={faqSection.title} itemsFAQ={faqSection.accordionItems} hoverColor={'grey'} />
      </section>
    </>
  );
};

export default DedicatedTeamsComponent;
